import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// 挂载Vuex
Vue.use(Vuex)

// 创建VueX对象
const store = new Vuex.Store({
  state: {
    // 存放的键值对就是所要管理的状态
    // 读者卡号
    rcardId: '',
    // 余额
    balance: '',
    // 用户登录名
    uid: '',
    // 实名认证
    idno: '',
    // 用户信息
    userInfo: ''
  },
  mutations: {
    changeRcardId (state, key) {
      state.rcardId = key
    },
    changeBalance (state, key) {
      state.balance = key
    },
    changeUid (state, key) {
      state.uid = key
    },
    changeIdno (state, key) {
      state.idno = key
    },
    changeUserInfo (state, key) {
      state.userInfo = key
    }
  },
  //把所有数据缓存到本地
  plugins: [createPersistedState()],
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js